module.exports = __webpack_public_path__ + "static/media/15UN-Habitat9.cc7699d8.jpg";